export default __webpack_public_path__ + "static/media/TVOC.11a91423.svg";